<template>
    
    <v-card style="margin-top: 20px;" class="d-flex justify-space-between align-center flex-wrap">

        <v-card-title class="text_primary">
            <v-icon left class="text_primary">
                mdi-file-document-outline
            </v-icon>
            {{ `說明` }}
            <v-spacer></v-spacer>
        </v-card-title>
            
        <v-card-text>

            <v-container fluid>
            
                <v-row
                    cols="12"
                    class="d-flex justify-space-between align-center"
                >

                    <v-card-subtitle >
                        {{ description }}
                    </v-card-subtitle>

                    <div>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn 
                                    :style="{
                                        backgroundColor: 'transparent',
                                        boxShadow: 'none'
                                    }"
                                    class="edit_btn"
                                    @click="openDialog"
                                    v-bind="attrs"
                                    v-on="on"
                                    :disabled="is_disabled"
                                >
                                    <v-icon>
                                        mdi-pencil
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>編輯說明</span>
                        </v-tooltip>
                    </div>

                </v-row>

            </v-container>

        </v-card-text>
         
        <DialogForm 
            v-if="is_open_description_dialog"
            :dialogSetting="dialog_setting"
            @submit="editDescription"
            @close="closeDialog"
        />

    </v-card>    

</template>

<script>

// 子元件
import DialogForm from '@/components/Utils/DialogForm.vue'

import {
  apiPatchExperiment
} from '@/api/optimize.js'

export default {
    name: "Description",
    components: {
      DialogForm
    },
    props: {
        experiment: Object
    },
    data() {
        return {
            is_open_description_dialog: false,
            dialog_setting: {
                title: '編輯實驗/個人化作業說明',
                fields: [
                    {
                        "id": "memo",
                        "label": "說明",
                        "value": null,
                        "hint": "加入對組織成員有幫助的說明。",
                        "type": 'text'
                    }
                ],
                submit_text: '完成',
                submit_callback: 'submit',
                close_callback: 'close',
                views: null
            },
            description_text: ''
        }
    },
    created() {

    },
    mounted() {
        console.log("yo Description.vue");
    },
    methods: {
        openDialog() {
            this.dialog_setting.fields[0]['value'] = this.experiment.memo
            this.is_open_description_dialog = true
        },
        closeDialog() {
            this.is_open_description_dialog = false
        },
        async editDescription(item) {
            console.log(item);
            let params = {
                "target_type": "abtest", //先寫死，目前也只有這一個type
            }

            item.forEach( field => {
                params[field.id] = field.value
            })

            console.log("140行", params);

            await apiPatchExperiment(
                this.$route.params.experiment_id, this.$route.params.org_id, params
            )
            .then( async resp => {
                console.log(resp)
                this.closeDialog()
                if (resp.data.code !== 200) {
                    this.$root.vtoast.show({
                        message: "更新實驗失敗，原因: " + resp.data.msg !== "" ? resp.data.msg : "更新實驗失敗!"
                    })
                } else {
                    this.$root.vtoast.show({
                        message: "更新實驗成功！",
                        color: 'primary'
                    })
                    delete params.target_type
                    // Object.hasOwn(params, 'url') ? params.url = decodeURIComponent(params.url) : params
                    this.$store.commit('update_selected_experience', params)
                }
            })
            .catch(error => {
                console.log(error);
                this.$root.vtoast.show({
                    message: "更新實驗失敗，原因: " + error.response ? error.response : error
                })
            })

        }
    },
    computed: {
        isHaveDescriptionText() {
            return this.description_text !== ''
        },
        is_disabled() {
            return (this.experiment.enable && this.experiment.is_release) || (this.experiment.enable === false && this.experiment.is_release)
        },
        description() {
            return this.experiment.memo ? this.experiment.memo : "尚未新增任何說明。"
        }
    }
}

    

</script>

<style scoped>

    /* .edit_btn {
        background-color: transparent;
        box-shadow: none;
    } */

    .edit_btn:hover{
        background-color: #fff;
    }

    .v-btn:not(.v-btn--round).v-size--default {
        height: 36px;
        min-width: 36px;
        margin: 0 10px 0 0;
        padding: 0;
        border-radius: 50%;
    }

</style>
